module.exports = __webpack_public_path__ + "assets/images/hamburger068ab4890a44e214fce838af8d08d2dd.svg";